export type AgentFinding = {
  code?: string;
  severity?: string;
  path?: string;
  summary?: string;
  cite?: Record<string, unknown>;
};

/** GET …/reviews/:id/findings — `{ summary, findings }`. summary is the code=summary text (or null). */
export type FindingsEnvelope = {
  summary: string | null;
  findings: AgentFinding[];
};

function summaryFromFindings(findings: AgentFinding[]): string | null {
  const overall = findings.find((f) => f.code === "summary" && !f.path);
  const hit = overall ?? findings.find((f) => f.code === "summary");
  return typeof hit?.summary === "string" && hit.summary.length > 0 ? hit.summary : null;
}

/** Accept array, `{ findings }`, or `{ summary, findings }` (back-compat). */
export function parseFindingsEnvelope(raw: unknown): FindingsEnvelope {
  if (Array.isArray(raw)) {
    const findings = raw as AgentFinding[];
    return { summary: summaryFromFindings(findings), findings };
  }
  if (raw && typeof raw === "object") {
    const rec = raw as { summary?: unknown; findings?: unknown };
    const findings = Array.isArray(rec.findings) ? (rec.findings as AgentFinding[]) : [];
    const summary =
      typeof rec.summary === "string" && rec.summary.length > 0 ? rec.summary : summaryFromFindings(findings);
    return { summary, findings };
  }
  return { summary: null, findings: [] };
}
